module.exports = __webpack_public_path__ + "static/media/back-arrow.84722299.svg";